import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";

const FALLBACK = ["HARD TECHNO", "TRANCE", "NEXT DATE ANNOUNCED SOON", "ALL NIGHT LONG", "RAW SOUND", "NO COMPROMISE"];

const shortName = (name = "") => name.split(/\s+(?:EXHILARATION\s+)?presents\b|:/i)[0].trim() || name;

const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short" }).toUpperCase();

const buildItems = (e) =>
    [
        shortName(e.name).toUpperCase(),
        formatDate(e.startDate),
        e.lineup?.[0] && `HEADLINER · ${e.lineup[0].toUpperCase()}`,
        "TICKETS ON SKIDDLE",
    ].filter(Boolean);

export default function Marquee() {
    const [items, setItems] = useState(FALLBACK);

    useEffect(() => {
        axios
            .get(`${API}/events`)
            .then((r) => {
                const next = (r.data.events || [])
                    .filter((e) => new Date(e.startDate).getTime() > Date.now())
                    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))[0];
                if (next) setItems(buildItems(next));
            })
            .catch(() => {});
    }, []);

    const row = Array.from({ length: Math.ceil(16 / items.length) * 2 }, () => items).flat();
    return (
        <div className="relative border-y border-white/10 bg-[#0C0C0F] py-5 overflow-hidden" data-testid="live-marquee">
            <div className="marquee-track items-center gap-10 pr-10">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-10 shrink-0" data-testid={i < items.length ? `marquee-item-${i}` : undefined}>
                        <span
                            className={`font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl whitespace-nowrap ${
                                i % 4 === 2 ? "text-stroke" : i % 4 === 1 ? "text-[#CCFF00]" : "text-[#F4F4F6]"
                            }`}
                        >
                            {item}
                        </span>
                        <span className="h-2 w-2 rotate-45 bg-[#FF2B56] shrink-0" aria-hidden="true" />
                    </span>
                ))}
            </div>
        </div>
    );
}
